// src/api_scripts/createQueue.js
import { createApiClient } from "../apiClient";

const createQueue = async (queueData, orgId, accessToken, setProgress) => {
  const { name } = queueData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Queue: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new  Queue
  const relativeUri = `/organization/${orgId}/v2/contact-service-queue`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, queueData);

    const newQueue = response.data; // The API returns the created resource directly

    console.log("Create Queue API Response Data:", newQueue);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Queue "${name}" (ID: ${newQueue.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newQueue.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating Queue "${name}":`, error);

    let errorMessage = `Error creating Queue "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createQueue;
